import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';
import { makeObservable, observable } from 'mobx';

export interface IRouteFeeOptionAttributes extends IModelAttributes {
	routeId: string;
	feeOptionId: string;

	route: Models.RouteEntity | Models.IRouteEntityAttributes;
	feeOption: Models.FeeOptionEntity | Models.IFeeOptionEntityAttributes;
}

@entity('RouteFeeOption')
export default class RouteFeeOption extends Model implements IRouteFeeOptionAttributes {
	@observable
	@attribute()
	public routeId: string;

	@observable
	@attribute()
	public feeOptionId: string;

	@observable
	@attribute({ isReference: true })
	public route: Models.RouteEntity;

	@observable
	@attribute({ isReference: true })
	public feeOption: Models.FeeOptionEntity;

	constructor(attributes?: Partial<IRouteFeeOptionAttributes>) {
		super(attributes);

		makeObservable(this);

		if (attributes) {
			if (attributes.routeId) {
				this.routeId = attributes.routeId;
			}
			if (attributes.feeOptionId) {
				this.feeOptionId = attributes.feeOptionId;
			}

			if (attributes.route) {
				if (attributes.route instanceof Models.RouteEntity) {
					this.route = attributes.route;
					this.routeId = attributes.route.id;
				} else {
					this.route = new Models.RouteEntity(attributes.route);
					this.routeId = this.route.id;
				}
			} else if (attributes.routeId !== undefined) {
				this.routeId = attributes.routeId;
			}

			if (attributes.feeOption) {
				if (attributes.feeOption instanceof Models.FeeOptionEntity) {
					this.feeOption = attributes.feeOption;
					this.feeOptionId = attributes.feeOption.id;
				} else {
					this.feeOption = new Models.FeeOptionEntity(attributes.feeOption);
					this.feeOptionId = this.feeOption.id;
				}
			} else if (attributes.feeOptionId !== undefined) {
				this.feeOptionId = attributes.feeOptionId;
			}
		}
	}
}
